// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 445 ? "bc98253f" : chunkId) + "." + {"124":"c2f14a12fc84ed36","250":"1a2268a2045f2784","445":"d0f48d944b070607","581":"135b3b182b54bb5c"}[chunkId] + ".js";
};